<script>
  import { layoutMethods, peddlrWalletKycMethods, peddlrWalletKycComputed } from "@/state/helpers";
  import profileKycActivityLog from "@/views/pages/profileInformation/profileKycActivityLog.vue";
  import axios from 'axios';

  /**
   * KYC Details component
   */
  export default {
    page: {
      title: "KYC Details"
    },
    components: {
      profileKycActivityLog,
    },
    computed: {
      ...peddlrWalletKycComputed
    },
    data() {
      return {
        title: "KYC Details",
        businessId: 0,
        infoType  : null,
        userKycInformation: {
          firstName: null,
          middleName: null,
          lastName: null,
          gender: null,
          address: null,
          email: null,
          mobileNumber: null,
          birthday: null,
          birthplace: null,
          nationality: null,
          kycAccountType: null,
          kycAccountStatus: null,
          walletAccountNum: null,
          uploadedSelfie: null,
          livenessCheck: null,
          uploadedId: null,
          signatureBiometrics: null,
          dateVerified: null,
          dateSubmitted: null,
          kycDateVerified: null,
        },
        userKycPhotoUrl: {
          kycPhotos: {
            selfieUrl: null,
            idFrontPhotoUrl: null,
            idBackPhotoUrl: null,
            signatureUrl: null
          }
        },
        isLightboxVisible: false,
        lightBoxImageUrl: "",
        tempImageUrl: require("@/assets/images/small/img-1.jpg"),
        tempImageUrl2: require("@/assets/images/small/img-2.jpg"),
        tempImageUrl3: require("@/assets/images/small/img-3.jpg"),
        tempImageUrl4: require("@/assets/images/small/img-4.jpg"),
        errorImagePlaceholder: require("@/assets/images/img-placeholder.png"),
        shuftiPhotoUrl: null,
        shuftiDetails: {
          dob: null,
          name: { 
            first_name: null,
            middle_name: null,
            last_name: null
          }
        },
        showGenerateKycModal: false,
        showGenerateKycSuccessModal: false,
        hasGeneratedLink: false,
        generatedKycLink: '',
        linkIsExpired: false,
      };
    },
    methods: {
      ...layoutMethods,
      ...peddlrWalletKycMethods,
      async fetchKycDetails() {
        await this.getUserKycDetails({
            businessId: this.businessId
        }).then(() => {
            this.userKycInformation = this.userKycDetails;
            this.generatedKycLink = this.userKycInformation.kycUrl;
        }).catch((err) => {
            console.error("err", err);
        })
      },
      async fetchKycPhotos() {
        await this.getUserKycPhotos({
            businessId: this.businessId
        }).then(() => {
            this.userKycPhotoUrl = this.userKycPhotos;
            this.shuftiDetails = this.userKycPhotos['kycPhotos'];
            console.log("GET RAW: ", this.shuftiDetails)
        }).catch((err) => {
            console.error("err", err);
        })
      },
      async fetchUserShuftiPhoto(imgType, kycMethod) {      
        if (kycMethod == "shufti") {
          let accessToken = this.userKycPhotoUrl.kycPhotos.accessToken;
          let imgUrl = null;
  
          switch (imgType) {
            case 'selfieUrl':
              imgUrl = this.userKycPhotoUrl.kycPhotos.selfieUrl;
              break;
            case 'idFrontPhotoUrl':
              imgUrl = this.userKycPhotoUrl.kycPhotos.idFrontPhotoUrl;
              break;
          
            default:
              break;
          }
  
          // Get the image file/URL from Shufti
          await this.getShuftiImg(imgUrl, accessToken)
        } else {
          this.shuftiPhotoUrl = imgType == "selfieUrl" ? this.userKycPhotoUrl.kycPhotos.selfieUrl : this.userKycPhotoUrl.kycPhotos.idFrontPhotoUrl
          this.lightBoxImageUrl = this.shuftiPhotoUrl ? this.shuftiPhotoUrl : this.errorImagePlaceholder
          this.isLightboxVisible = true;
        }
      },
      async getShuftiImg(imgUrl, accessToken){
          await axios.post(imgUrl, 
                           { access_token: accessToken }, 
                           { responseType: 'arraybuffer' })
          .then(({ data }) => {
              let tmp = Buffer.from(data).toString('base64');

              this.shuftiPhotoUrl = "data:image/jpeg;base64," + tmp
              this.lightBoxImageUrl = this.shuftiPhotoUrl ? this.shuftiPhotoUrl : this.errorImagePlaceholder
              this.isLightboxVisible = true;
          })
          .catch(({ response }) => {
              console.log("Error: ", response.message)
          });
      },
      openModal(modal=''){
        this.$bvModal.show(modal);
      },
      closeModal(modal=''){
        this.$bvModal.hide(modal);
      },
      isEmpty(value){
        return (
        // null or undefined
        (typeof value == "undefined") || 
        (value == undefined) ||
        (value == null) ||
        (value === "") ||
        // has length and it's zero
        (Object.prototype.hasOwnProperty.call(value,'length') && value.length === 0) ||
        // is an Object and has no keys
        (value.constructor === Object && Object.keys(value).length === 0)
        )
      },
      async generateKycLink() {
        await this.generateKycUrl({
          userId: this.userKycInformation.subscriberId,
        })
        .then(async () => {
          await this.fetchKycPhotos();
          await this.fetchKycDetails()
            .then(() => {
              this.generatedKycLink = this.generatedKycUrl;
              this.showGenerateKycModal = false;
              this.showGenerateKycSuccessModal = true;
            });
        })
      },
      async onCopyLinkClicked() {
        try {
          if (this.userKycInformation.isKycUrlExpired) {
            this.showGenerateKycModal = true;
          } else {
            await navigator.clipboard.writeText(this.generatedKycLink)
              .then(() => {
                this.showGenerateKycSuccessModal = false;
                this.$toast.showToast('link', 'Copied Generated Link', 'Successfully copied the generated link');
              });
          }
        } catch (error) {
          console.log("Error while copying link: ", error);
        }
      },
    },
    async mounted(){
      this.businessId = this.$route.params.bid
      this.infoType = this.$route.params.tab;
      this.changeTitle({title: 'KYC Details'});
      this.changeBreadCrumb({
        breadCrumbs: [
          { text: 'Peddlr', to: { name: 'Home'} },
          { text: 'Merchant List', to: { name: 'Subscriber'} },
          { text: 'Merchant Details', to: { name: 'Profile Information', params: { tab: this.infoType, bid: this.businessId}} },
          { text: "KYC Form", to: { name: 'Profile Information Kyc', params: { tab: this.infoType, bid: this.businessId}} }
        ]
      });
      this.fetchKycDetails();
      this.fetchKycPhotos();
    }
  }
    
</script>


<template>
  <div><!-- outer div-->
    <div class="card">
      <div class="card-header fw-bold" @click="fetchKycPhotos()">
          KYC Details
      </div>
      <div class="card-body">
        <div class="col-md-12">
          <p class="font-size-15 fw-medium mb-2">Date Verified</p>
          <p class="font-size-15 fw-medium m-0">
              <span v-if="userKycInformation.kycAccountType == 'FullyVerified' && userKycInformation.kycDateVerified">{{ userKycInformation.kycDateVerified | customFormatDate }}</span>
              <span v-else>--</span>
          </p>
          <p class="font-size-12 m-0">Date Submitted: 
              <span v-if="userKycInformation.kycDateVerified">{{ userKycInformation.kycDateVerified | customFormatDate }}</span>
              <span v-else>--</span>
          </p>
          <!-- <p class="font-size-12 mb-1">Date Verified</p> -->
          <!-- <p class="font-size-15 fw-medium" v-if="userKycInformation.kycDateVerified">{{ userKycInformation.kycDateVerified | customFormatDate }}</p> -->
          <!-- <p class="font-size-15 fw-medium" v-else>--</p> -->
        </div>

        <div class="row mt-4">
          <div class="col-sm-6 col-md-6">
            <p class="font-size-15 fw-medium mb-2">KYC Account Type</p>
            <span class="badge rounded-pill bg-success kyc-pill" v-if="userKycInformation.kycAccountType == 'FullyVerified'">
              <i class="bx bxs-badge-check"></i> Fully Verified
            </span>
            <span class="badge rounded-pill bg-danger kyc-pill" v-if="userKycInformation.kycAccountType == 'FailedKYC'">
              <i class="bx bxs-user-x"></i> Failed KYC
            </span>
            <span class="badge rounded-pill bg-warning kyc-pill" v-if="userKycInformation.kycAccountType == 'NoKYC'">
              <i class="bx bx-window-close"></i> Don't Have KYC
            </span>
          </div>
          <div class="col-sm-6 col-md-6">
            <p class="font-size-15 fw-medium mb-2">KYC Account Status</p>
            <span class="fw-semibold" 
                  :class="{ 
                      'text-success': userKycInformation.kycAccountStatus == 'Live',
                      'text-danger': userKycInformation.kycAccountStatus == 'FailedVerification',
                      'text-pending': userKycInformation.kycAccountStatus == 'PendingVerification'
                  }">
                {{ userKycInformation.kycAccountStatus | formatKycAccountStatus }}
            </span>
          </div>
        </div>

        <div class="row mt-4">
          <div class="col-sm-6 col-md-6">
            <p class="font-size-15 fw-medium mb-2">Wallet Account Number</p>
            <p class="font-size-15 fw-medium">
              {{ isEmpty(userKycInformation.walletAccountNum) ? '--' : userKycInformation.walletAccountNum }}
            </p>
          </div>
          <div class="col-sm-6 col-md-6">
            <p class="font-size-15 fw-medium mb-2">Uploaded Selfie</p>
            <p class="font-size-15 fw-medium">Photo
              <span class="text-primary fw-semibold" v-if="userKycPhotoUrl.kycPhotos.selfieUrl != null">
                <a href="javascript:void(0);"
                  @click="fetchUserShuftiPhoto('selfieUrl', userKycPhotoUrl.kycPhotos.kycMethod);"
                >View</a>
                <!-- @click="lightBoxImageUrl = tempImageUrl; " -->
              </span>
              <small class="text-muted" v-else>
                (No data found)
              </small>
            </p>
          </div>
        </div>

        <div class="row mt-3">
          <div class="col-sm-6 col-md-6">
            <p class="font-size-15 fw-medium mb-2">Uploaded ID</p>
            <p class="font-size-15 fw-medium">Photo
              <span class="text-primary fw-semibold" v-if="userKycPhotoUrl.kycPhotos.idFrontPhotoUrl != null">
                <a href="javascript:void(0);"
                   @click="fetchUserShuftiPhoto('idFrontPhotoUrl', userKycPhotoUrl.kycPhotos.kycMethod);"
                >View</a>
              </span>
              <small class="text-muted" v-else>
                (No data found)
              </small>
            </p>
          </div>
          <div class="col-sm-6 col-md-6">
            <p class="font-size-15 fw-medium mb-2">Signature or Biometrics</p>
            <p class="font-size-15 fw-medium">Verification
              <span class="text-primary fw-semibold" v-if="userKycPhotoUrl.kycPhotos.signatureUrl != null">
                <a href="javascript:void(0);"
                   @click.prevent="lightBoxImageUrl = userKycPhotoUrl.kycPhotos.signatureUrl; isLightboxVisible = true;"
                >View</a>
              </span>
              <small class="text-muted" v-else>
                (No data found)
              </small>
            </p>
          </div>
        </div>
        <div class="row mt-3" v-if="userKycInformation.kycAccountType == 'FailedKYC'">
          <div class="col-md-12">
            <p class="font-size-15 fw-medium mb-2">Verification Reason:</p>
            <p class="font-size-15 fw-medium">
              {{ isEmpty(userKycPhotoUrl.kycPhotos.declinedreason) ? "--" : userKycPhotoUrl.kycPhotos.declinedreason  }}
            </p>
          </div>
        </div>

        <vue-easy-lightbox
              moveDisabled
              :visible="isLightboxVisible"
              :imgs="lightBoxImageUrl"
              @hide="isLightboxVisible = false"
        ></vue-easy-lightbox>
        
        <div class="card-header"></div> <!-- Divider -->

        <div class="row mt-3">
          <div class="col-sm-4 col-md-4">
            <p class="font-size-12 mb-1">First Name</p>
            <p class="font-size-15 fw-medium">{{ !isEmpty(shuftiDetails) ? shuftiDetails.name.first_name : userKycInformation.firstName || '--' }}</p>
          </div>
          <div class="col-sm-4 col-md-4">
            <p class="font-size-12 mb-1">Middle Name</p>
            <p class="font-size-15 fw-medium">{{ !isEmpty(shuftiDetails) ? shuftiDetails.name.middle_name : userKycInformation.middleName || '--' }}</p>
          </div>
          <div class="col-sm-4 col-md-4">
            <p class="font-size-12 mb-1">Last Name</p>
            <p class="font-size-15 fw-medium">{{ !isEmpty(shuftiDetails) ? shuftiDetails.name.last_name : userKycInformation.lastName || '--' }}</p>
          </div>
        </div>

        <div class="row mt-3">
          <div class="col-sm-4 col-md-4">
            <p class="font-size-12 mb-1">Gender</p>
            <p class="font-size-15 fw-medium text-capitalize">{{ isEmpty(userKycInformation.gender) ? '--' : userKycInformation.gender }}</p>
          </div>
          <div class="col-sm-4 col-md-4">
            <p class="font-size-12 mb-1">Date of Birth</p>
            <p class="font-size-15 fw-medium">{{ isEmpty(shuftiDetails.dob) ? userKycInformation.birthday : shuftiDetails.dob | formatDateOnly }}</p>
          </div>
        </div>

        <div class="row mt-3">
          <div class="col-md-12">
            <p class="font-size-12 mb-1">Business Address</p>
            <p class="font-size-15 fw-medium">{{ isEmpty(userKycInformation.address) ?  '--' : userKycInformation.address }}</p>
          </div>
        </div>

        <div class="row mt-3">
          <div class="col-md-4">
            <p class="font-size-12 mb-1">Email Address</p>
            <p class="font-size-15 fw-medium">{{ isEmpty(userKycInformation.email) ? '--' : userKycInformation.email }}</p>
          </div>
          <div class="col-md-4">
            <p class="font-size-12 mb-1">Phone Number</p>
            <p class="font-size-15 fw-medium">{{ isEmpty(userKycInformation.mobileNumber) ? '--' : userKycInformation.mobileNumber }}</p>
          </div>
          <div class="col-md-4">
            <p class="font-size-12 mb-1">City of Birth</p>
            <p class="font-size-15 fw-medium">{{ isEmpty(userKycInformation.birthplace) ? '--' : userKycInformation.birthplace }}</p>
          </div>
        </div>
        
        <div class="row mt-3">
          <div class="col-md-4">
            <p class="font-size-12 mb-1">Country of birth (Nationality)</p>
            <p class="font-size-15 fw-medium">{{ isEmpty(userKycInformation.nationality) ? '--' : userKycInformation.nationality }}</p>
          </div>
        </div>

        <div class="row mt-3" v-if="!isEmpty(userKycInformation.kycUrl)">
          <p style="font-size: 16px;">Please copy the generated link and send to the user that they can undergo KYC again.</p>
          <div class="d-flex col-lg-4 col-sm-12">
            <b-form-input disabled class="rounded-0 rounded-start" v-model="generatedKycLink"></b-form-input>
            <b-button type="button" variant="primary" class="btn btn-primary rounded-0 rounded-end d-flex copy-link-btn text-center" @click="onCopyLinkClicked()">
              <i class="bx bx-link"></i>Copy Link
            </b-button>
          </div>
          <p v-if="userKycInformation.isKycUrlExpired" class="small fst-italic note-txt mt-2">*Link has expired. Clicking Copy Link will generate a new link.</p>
        </div>

        <div class="card-header"></div> <!-- Divider -->

        <div class="kyc-al-container d-flex align-items-center">
          <div class="activity-log">
            <p class="font-size-15 fw-medium mb-0">Activity Log: 
              <b-link class="fw-semibold" @click="openModal ('bv-modal-kyc-activity-log')">View</b-link>
            </p>
          </div>
          <div class="me-2" v-if="isEmpty(userKycInformation.kycUrl)"> 
            <b-button type="button" class="btn btn-danger generateKycBtn px-4" @click="showGenerateKycModal = true">Generate Re-KYC Link</b-button>
          </div>
          <div class="btn-back">
            <router-link :to="{ name: 'Profile Information', params: {tab: 'Profile', bid: businessId} }">
              <b-button class="px-5" type="button" variant="light">Back</b-button>
            </router-link>
          </div> <!-- End of BACK button -->
        </div>

      </div>
    </div>


    <!-- Change Log MODAL -->
    <b-modal id="bv-modal-kyc-activity-log" 
             title="Reason Log" 
             size="lg" 
             centered
             hide-header 
             hide-title 
             hide-footer 
             hide-header-close
             no-close-on-backdrop>

      <profile-kyc-activity-log/>

      <div class="text-end mt-3 mb-1">
        <b-button class="w-sm"
                  type="button"
                  variant="light"
                  @click="closeModal('bv-modal-kyc-activity-log')"
                  >Close
        </b-button>
      </div>
    </b-modal><!--bv-modal-kyc-activity-log-->

    <!-- #region Generate KYC Link Modal -->
    <b-modal v-model="showGenerateKycModal" size="md" centered hide-header hide-footer hide-header-close no-close-on-backdrop>
      <div class="px-2 py-3">
        <div class="col-md-12 text-center">
          <i class="bx bx-user-pin mb-1"></i>
          <p class="fw-bold mt-2" style="font-size: 1.5em;">Generate Re-KYC</p>
          <p class="mt-2 mb-4">You are about to generate a re-KYC link and delete the information of the user. Please secure their consent before confirming.</p>
          <p class="small fst-italic note-txt">*Please note that the data will not be retrieved anymore once you confirm.</p>
          <div class="d-flex justify-content-center mt-4">
            <b-button type="button" variant="light" class="w-sm btn-cancel" @click="showGenerateKycModal = false" >Cancel</b-button>
            <b-button type="button" class="btn w-sm ms-2 btn-ok" @click="generateKycLink()">Confirm</b-button>
          </div>
        </div>
      </div>
    </b-modal>
    <!-- #endregion -->

    <!-- #region Generate KYC Link Successful Modal -->
    <b-modal v-model="showGenerateKycSuccessModal" size="md" centered hide-header hide-footer hide-header-close no-close-on-backdrop>
      <div class="success-kyc-div">
        <div class="col-md-12 text-center">
          <img src="@/assets/images/check-circle.png" alt="Check Circle Icon" class="mb-1 check-icon">
          <p class="fw-bold mt-2" style="font-size: 1.5em;">Generate KYC Successful!</p>
          <p class="mt-2 mb-4">Please copy the generated link and send to the user that they can undergo KYC again.</p>
          <div class="d-flex">
            <b-form-input disabled class="rounded-0 rounded-start" v-model="generatedKycLink"></b-form-input>
            <b-button type="button" variant="primary" class="btn btn-primary rounded-0 rounded-end d-flex copy-link-btn text-center" @click="onCopyLinkClicked()">
              <i class="bx bx-link"></i>Copy Link
            </b-button>
          </div>
          <div class="d-flex justify-content-center mt-4">
            <b-button type="button" variant="light" class="w-sm btn-cancel" @click="showGenerateKycSuccessModal = false">OK</b-button>
          </div>
        </div>
      </div>
    </b-modal>
    <!-- #endregion -->
  </div> <!-- end of outer div-->
</template>


<style>
  .kyc-pill {
    font-size: 14px;
    padding: 8px 15px;
  }

  .kyc-al-container {
    display: flex;
    margin: 20px 0 10px;

    .activity-log {
      flex: 1;
    }
  }

  .text-pending {
    color: #DC7512;
  }
  .text-disabled {
    color: #ccc;
  }
  .text-danger {
    color: #9A211F;
  }
  .text-success {
    color: #508F30;
  }

  .vel-img {
    background: white !important;
  }

  .generateKycBtn, .generateKycBtn:hover, .btn-ok, .btn-ok:hover {
    background-color: #9A211F;
    border-color: #9A211F;
  }

  .bx-user-pin {
    font-size: 90px;
    color: #9A211F;
  }

  .note-txt {
    color: #9A211F;
    font-size: smaller;
  }

  .btn-cancel {
    border: 2px solid #B6B2EC;
  }

  .success-kyc-div {
    padding: 1rem 3.5rem;
  }

  .check-icon {
    width: 90px;
    height: 90px;
  }

  .bx-link {
    font-size: 20px;
  }

  .copy-link-btn {
    padding-left: 5px;
    padding-right: 5px;
    width: 142px;
  }
</style>